"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PlusOutline = {
  name: 'plus',
  theme: 'outline',
  nameWithTheme: 'plus-o',
  tag: 'svg',
  attrs: {
    xmlns: 'http://www.w3.org/2000/svg',
    class: 'icon',
    viewBox: '0 0 1024 1024'
  },
  children: [{
    tag: 'path',
    attrs: {
      d: 'M848 474H550V152h-76v322H176c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h298v322h76V550h298c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'
    },
    children: []
  }]
};
exports.default = PlusOutline;